const Anonymous = ({ size = 24, className = '', currentColor = '#666666' }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 114 114"
      fill={currentColor}
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      className={className}
    >
      <path
        d="M60.7305 113.879C59.4972 113.959 58.2534 114 57 114C55.7463 114 54.5021 113.959 53.2686 113.879L53.5264 109.888C54.6741 109.962 55.8324 110 57 110C58.1676 110 59.3259 109.962 60.4736 109.888L60.7305 113.879Z"
        fill={currentColor}
      />
      <path
        d="M39.957 107.201C42.1287 107.938 44.364 108.539 46.6523 108.991L45.876 112.914C43.4136 112.427 41.0082 111.782 38.6709 110.988L39.957 107.201Z"
        fill={currentColor}
      />
      <path
        d="M75.3281 110.988C72.9908 111.782 70.5855 112.427 68.123 112.914L67.3477 108.991C69.636 108.539 71.8713 107.938 74.043 107.201L75.3281 110.988Z"
        fill={currentColor}
      />
      <path
        d="M27.5557 101.075C29.4716 102.358 31.4751 103.519 33.5557 104.547L31.7842 108.132C29.5458 107.026 27.3904 105.778 25.3301 104.398L27.5557 101.075Z"
        fill={currentColor}
      />
      <path
        d="M88.5068 104.155L88.6689 104.398C86.6086 105.778 84.4532 107.026 82.2148 108.132L80.4443 104.547C82.5249 103.519 84.5284 102.358 86.4443 101.075L88.5068 104.155Z"
        fill={currentColor}
      />
      <path
        d="M17.1504 91.9443C18.6771 93.6838 20.3162 95.3229 22.0557 96.8496L19.417 99.8545C17.5472 98.2133 15.7856 96.4519 14.1445 94.582L17.1504 91.9443Z"
        fill={currentColor}
      />
      <path
        d="M99.8545 94.582C98.2133 96.4519 96.4519 98.2133 94.582 99.8545L91.9443 96.8496C93.6838 95.3229 95.3229 93.6838 96.8496 91.9443L99.8545 94.582Z"
        fill={currentColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M56.6357 20.1318L57.3232 20.1426C64.0511 20.3603 70.4464 23.2333 75.2061 28.1777C79.9656 33.1222 82.7318 39.7658 82.9414 46.7549L82.9512 47.6064L83.5361 47.6279C85.9619 47.7759 88.2515 48.843 89.9697 50.6279C91.688 52.413 92.716 54.7915 92.8584 57.3115L92.875 57.916C92.875 60.6491 91.83 63.2705 89.9697 65.2031C88.1093 67.1358 85.5852 68.2217 82.9541 68.2217L82.9512 74.0479L89.0127 83.4951C89.3268 83.9851 89.5145 84.5507 89.5576 85.1377C89.6007 85.7248 89.4978 86.3138 89.2588 86.8477C89.0197 87.3816 88.6524 87.8434 88.1924 88.1875C87.7325 88.5314 87.1949 88.7463 86.6318 88.8125L86.2617 88.833H53.1934C41.8014 88.8399 32.2712 80.2793 30.373 68.8262L30.2803 68.2148L30.0449 68.2188C27.5148 68.2188 25.0802 67.2142 23.2393 65.4111C21.3983 63.6078 20.2901 61.1416 20.1416 58.5176L20.125 57.916C20.125 55.1829 21.1699 52.5616 23.0303 50.6289C24.8906 48.6963 27.414 47.6105 30.0449 47.6104L30.0586 46.752C30.2734 39.6156 33.1536 32.8461 38.0889 27.877C43.0241 22.9078 49.627 20.128 56.5 20.1279V20.125L56.6357 20.1318ZM56.5 54.4805C54.746 54.4805 53.0635 55.2047 51.8232 56.4932C50.583 57.7816 49.8867 59.5294 49.8867 61.3516C49.8868 62.2625 50.2345 63.1361 50.8545 63.7803C51.4746 64.4245 52.3163 64.7861 53.1934 64.7861H59.8066C60.6836 64.7861 61.5244 64.4244 62.1445 63.7803C62.7646 63.1361 63.1132 62.2626 63.1133 61.3516C63.1133 59.5295 62.417 57.7816 61.1768 56.4932C59.9365 55.2047 58.254 54.4805 56.5 54.4805ZM49.499 40.7637C48.6622 40.8671 47.8954 41.2994 47.3545 41.9707C46.8137 42.642 46.5396 43.5021 46.5889 44.376C46.6383 45.25 47.0072 46.0718 47.6201 46.6729C48.233 47.2739 49.0439 47.6094 49.8867 47.6104L50.3066 47.5859C51.1434 47.4824 51.9103 47.0511 52.4512 46.3799C52.9921 45.7085 53.2662 44.8477 53.2168 43.9736C53.1674 43.0996 52.7984 42.2778 52.1855 41.6768C51.5727 41.0759 50.7617 40.7412 49.9189 40.7402L49.499 40.7637ZM62.7266 40.7637C61.8896 40.8671 61.122 41.2993 60.5811 41.9707C60.0404 42.642 59.7671 43.5022 59.8164 44.376C59.8658 45.2499 60.234 46.0718 60.8467 46.6729C61.4595 47.2739 62.2705 47.6093 63.1133 47.6104L63.5332 47.5859C64.3701 47.4825 65.1377 47.0513 65.6787 46.3799C66.2197 45.7085 66.4937 44.8477 66.4443 43.9736C66.3949 43.0996 66.0259 42.2778 65.4131 41.6768C64.8002 41.0758 63.9893 40.7412 63.1465 40.7402L62.7266 40.7637Z"
        fill={currentColor}
      />
      <path
        d="M9.45312 80.4443C10.4811 82.5249 11.6421 84.5284 12.9248 86.4443L11.2617 87.5566L11.2627 87.5576L9.60059 88.6689C8.22127 86.6086 6.97308 84.4532 5.86719 82.2148L9.45312 80.4443Z"
        fill={currentColor}
      />
      <path
        d="M108.132 82.2148C107.026 84.4532 105.778 86.6086 104.398 88.6689L101.075 86.4443C102.358 84.5284 103.519 82.5249 104.547 80.4443L108.132 82.2148Z"
        fill={currentColor}
      />
      <path
        d="M5.00879 67.3477C5.4615 69.636 6.06182 71.8713 6.79883 74.043L3.01074 75.3281C2.21755 72.9909 1.57205 70.5854 1.08496 68.123L5.00879 67.3477Z"
        fill={currentColor}
      />
      <path
        d="M112.914 68.123C112.427 70.5855 111.782 72.9908 110.988 75.3281L107.201 74.043C107.938 71.8713 108.539 69.636 108.991 67.3477L112.914 68.123Z"
        fill={currentColor}
      />
      <path
        d="M4.1123 53.5264C4.03813 54.6741 4 55.8324 4 57C4 58.1676 4.03813 59.3259 4.1123 60.4736L0.120117 60.7305C0.0404466 59.4972 0 58.2533 0 57C0 55.7705 0.0385413 54.55 0.115234 53.3398L0.120117 53.2686L4.1123 53.5264Z"
        fill={currentColor}
      />
      <path
        d="M113.879 53.2686C113.959 54.5021 114 55.7463 114 57C114 58.2534 113.959 59.4972 113.879 60.7305L109.888 60.4736C109.962 59.3259 110 58.1676 110 57C110 55.8324 109.962 54.6741 109.888 53.5264L113.879 53.2686Z"
        fill={currentColor}
      />
      <path
        d="M6.79883 39.957C6.06182 42.1287 5.4615 44.364 5.00879 46.6523L1.08496 45.876C1.57209 43.4136 2.21751 41.0081 3.01074 38.6709L6.79883 39.957Z"
        fill={currentColor}
      />
      <path
        d="M110.988 38.6709C111.782 41.0082 112.427 43.4136 112.914 45.876L108.991 46.6523C108.539 44.364 107.938 42.1287 107.201 39.957L110.988 38.6709Z"
        fill={currentColor}
      />
      <path
        d="M12.9248 27.5557C11.6421 29.4716 10.4811 31.4751 9.45312 33.5557L5.86719 31.7842C6.97311 29.5459 8.22125 27.3904 9.60059 25.3301L12.9248 27.5557Z"
        fill={currentColor}
      />
      <path
        d="M104.398 25.3301C105.778 27.3904 107.026 29.5458 108.132 31.7842L104.547 33.5557C103.519 31.4751 102.358 29.4716 101.075 27.5557L104.398 25.3301Z"
        fill={currentColor}
      />
      <path
        d="M22.0557 17.1504C20.3162 18.6771 18.6771 20.3162 17.1504 22.0557L14.1445 19.417C15.7856 17.5472 17.5472 15.7856 19.417 14.1445L22.0557 17.1504Z"
        fill={currentColor}
      />
      <path
        d="M94.582 14.1445C96.4519 15.7856 98.2133 17.5472 99.8545 19.417L96.8496 22.0557C95.3229 20.3162 93.6838 18.6771 91.9443 17.1504L94.582 14.1445Z"
        fill={currentColor}
      />
      <path
        d="M33.5557 9.45312C31.4751 10.4811 29.4716 11.6421 27.5557 12.9248L25.3301 9.60059C27.3904 8.22125 29.5459 6.97311 31.7842 5.86719L33.5557 9.45312Z"
        fill={currentColor}
      />
      <path
        d="M82.2148 5.86719C84.4532 6.97308 86.6086 8.22127 88.6689 9.60059L87.6416 11.1377L86.4443 12.9248C84.5284 11.6421 82.5249 10.4811 80.4443 9.45312L82.2148 5.86719Z"
        fill={currentColor}
      />
      <path
        d="M46.6523 5.00879C44.364 5.4615 42.1287 6.06182 39.957 6.79883L38.6709 3.01074C41.0081 2.21751 43.4136 1.57209 45.876 1.08496L46.6523 5.00879Z"
        fill={currentColor}
      />
      <path
        d="M68.123 1.08496C70.5854 1.57205 72.9909 2.21755 75.3281 3.01074L74.043 6.79883C71.8713 6.06182 69.636 5.4615 67.3477 5.00879L68.123 1.08496Z"
        fill={currentColor}
      />
      <path
        d="M57 0C58.2533 0 59.4972 0.0404466 60.7305 0.120117L60.4736 4.1123C59.3259 4.03813 58.1676 4 57 4C55.8324 4 54.6741 4.03813 53.5264 4.1123L53.2686 0.120117C54.5021 0.0404051 55.7463 0 57 0Z"
        fill={currentColor}
      />
    </svg>
  );
};

export default Anonymous;
